"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const classNames = require("classnames");
exports.PageBody = (_a) => {
    var { children, fullscreen } = _a, otherProps = __rest(_a, ["children", "fullscreen"]);
    return (React.createElement("div", Object.assign({ className: classNames('page-comp-body', { 'page-comp-body-fullscreen': fullscreen }) }, otherProps), children));
};
exports.PageBody.displayName = 'PageBody';
exports.PageBody.defaultProps = {
    fullscreen: false,
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Page/PageBody.tsx
// module id = 363
// module chunks = 0